var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigbusiness3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_6742)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.125,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.9658,
    y1: 119.593,
    x2: 17.9658,
    y2: -21.9222,
    stroke: "url(#paint0_linear_75_6742)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.9658,
    y1: 119.593,
    x2: 52.9658,
    y2: -21.9222,
    stroke: "url(#paint1_linear_75_6742)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.9658,
    y1: 119.593,
    x2: 88.9658,
    y2: -21.9222,
    stroke: "url(#paint2_linear_75_6742)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.966,
    y1: 119.593,
    x2: 124.966,
    y2: -21.9222,
    stroke: "url(#paint3_linear_75_6742)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.966,
    y1: 119.593,
    x2: 160.966,
    y2: -21.9222,
    stroke: "url(#paint4_linear_75_6742)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.966,
    y1: 119.593,
    x2: 195.966,
    y2: -21.9222,
    stroke: "url(#paint5_linear_75_6742)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.966,
    y1: 119.593,
    x2: 231.966,
    y2: -21.9223,
    stroke: "url(#paint6_linear_75_6742)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 18.4539,
    x2: 258.387,
    y2: 18.4538,
    stroke: "url(#paint7_linear_75_6742)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 77.4539,
    x2: 258.387,
    y2: 77.4538,
    stroke: "url(#paint8_linear_75_6742)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 47.4539,
    x2: 258.387,
    y2: 47.4538,
    stroke: "url(#paint9_linear_75_6742)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.625,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "url(#paint10_linear_75_6742)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3997 53.3753C51.6512 43.1256 68.2727 43.1256 78.5224 53.3753C78.6444 53.4972 78.7411 53.6419 78.8072 53.8012C78.8732 53.9605 78.9071 54.1312 78.9071 54.3037C78.9071 54.4761 78.8732 54.6468 78.8072 54.8061C78.7411 54.9654 78.6444 55.1102 78.5224 55.2321L77.5949 56.1596C77.3488 56.4053 77.0152 56.5434 76.6674 56.5434C76.3196 56.5434 75.986 56.4053 75.7399 56.1596C67.0249 47.4463 52.8972 47.4463 44.1839 56.1596C43.9378 56.4053 43.6042 56.5434 43.2564 56.5434C42.9086 56.5434 42.575 56.4053 42.3289 56.1596L41.4014 55.2321C41.1556 54.986 41.0176 54.6524 41.0176 54.3046C41.0176 53.9567 41.1556 53.6231 41.4014 53.3771L41.3997 53.3753ZM46.9682 58.9438C54.1432 51.7688 65.7789 51.7688 72.9557 58.9438C73.0776 59.0657 73.1744 59.2104 73.2404 59.3697C73.3064 59.529 73.3404 59.6997 73.3404 59.8722C73.3404 60.0446 73.3064 60.2153 73.2404 60.3746C73.1744 60.5339 73.0776 60.6787 72.9557 60.8006L72.0282 61.7281C71.9063 61.8503 71.7614 61.9473 71.602 62.0134C71.4425 62.0796 71.2716 62.1136 71.0989 62.1136C70.9263 62.1136 70.7553 62.0796 70.5959 62.0134C70.4364 61.9473 70.2916 61.8503 70.1697 61.7281C67.4621 59.0206 63.79 57.4996 59.961 57.4996C56.1321 57.4996 52.46 59.0206 49.7524 61.7281C49.5063 61.9738 49.1727 62.1119 48.8249 62.1119C48.4771 62.1119 48.1435 61.9738 47.8974 61.7281L46.9699 60.8006C46.7241 60.5545 46.5861 60.2209 46.5861 59.8731C46.5861 59.5252 46.7241 59.1916 46.9699 58.9456L46.9682 58.9438ZM52.5752 64.5123C53.5502 63.5371 54.7078 62.7635 55.9818 62.2357C57.2559 61.7079 58.6214 61.4363 60.0004 61.4363C61.3795 61.4363 62.745 61.7079 64.019 62.2357C65.293 62.7635 66.4506 63.5371 67.4257 64.5123C67.5476 64.6342 67.6444 64.7789 67.7104 64.9382C67.7764 65.0975 67.8104 65.2682 67.8104 65.4407C67.8104 65.6131 67.7764 65.7838 67.7104 65.9431C67.6444 66.1024 67.5476 66.2472 67.4257 66.3691L66.4982 67.2966C66.3763 67.4185 66.2316 67.5153 66.0723 67.5813C65.913 67.6473 65.7422 67.6813 65.5698 67.6813C65.3974 67.6813 65.2266 67.6473 65.0673 67.5813C64.908 67.5153 64.7633 67.4185 64.6414 67.2966C64.032 66.687 63.3085 66.2034 62.5122 65.8735C61.7159 65.5436 60.8624 65.3738 60.0004 65.3738C59.1385 65.3738 58.285 65.5436 57.4887 65.8735C56.6924 66.2034 55.9688 66.687 55.3594 67.2966C55.1133 67.5423 54.7797 67.6804 54.4319 67.6804C54.0841 67.6804 53.7505 67.5423 53.5044 67.2966L52.5769 66.3691C52.3311 66.123 52.1931 65.7894 52.1931 65.4416C52.1931 65.0937 52.3311 64.7601 52.5769 64.5141L52.5752 64.5123ZM58.1437 70.0808C58.3874 69.8369 58.6769 69.6434 58.9955 69.5113C59.3141 69.3793 59.6556 69.3114 60.0004 69.3114C60.3453 69.3114 60.6868 69.3793 61.0054 69.5113C61.3239 69.6434 61.6134 69.8369 61.8572 70.0808C61.9791 70.2027 62.0759 70.3474 62.1419 70.5067C62.2079 70.666 62.2419 70.8367 62.2419 71.0092C62.2419 71.1816 62.2079 71.3523 62.1419 71.5116C62.0759 71.6709 61.9791 71.8157 61.8572 71.9376L60.9297 72.8651C60.8078 72.987 60.6631 73.0838 60.5038 73.1498C60.3445 73.2158 60.1737 73.2498 60.0013 73.2498C59.8289 73.2498 59.6581 73.2158 59.4988 73.1498C59.3395 73.0838 59.1948 72.987 59.0729 72.8651L58.1454 71.9376C57.8996 71.6915 57.7616 71.3579 57.7616 71.01C57.7616 70.6622 57.8996 70.3286 58.1454 70.0826L58.1437 70.0808Z",
    fill: "#83A735"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.625,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "url(#paint11_linear_75_6742)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3889 185.348C27.8088 185.348 29.6616 183.25 29.6616 180.973C29.6616 178.785 28.1883 177.424 25.1971 176.888L21.5584 176.263C19.7949 175.883 19.0359 175.459 19.0359 174.164C19.0359 172.825 20.1074 172.155 22.8308 172.155C25.9337 172.155 27.0275 173.071 27.0275 174.901V175.191H29.4161V175.057C29.4161 172.133 27.4293 169.945 23.0541 169.945C18.4109 169.945 16.625 172.133 16.625 174.298C16.625 176.754 18.4109 177.915 20.9334 178.361L24.5943 178.964C26.4918 179.321 27.2508 179.812 27.2508 181.107C27.2508 182.513 26.2462 183.138 23.3889 183.138C20.1074 183.138 19.0582 182.245 19.0582 180.46V180.102H16.6474V180.236C16.6474 183.384 18.9243 185.348 23.3889 185.348ZM38.6505 185.125V182.96H36.6414C35.2574 182.96 34.6323 182.603 34.6323 181.241V176.04H38.6505V174.03H34.6323V171.597H32.2438V174.03H30.3687V176.04H32.2438V181.375C32.2438 184.076 33.7171 185.125 36.1057 185.125H38.6505ZM43.4176 185.348C45.9401 185.348 47.7036 184.232 48.284 182.357H48.4403V185.125H50.6503V178.383C50.6503 175.727 49.0653 173.807 45.5383 173.807C42.0113 173.807 39.9129 175.705 39.9129 178.227V178.317H42.3015V178.227C42.3015 176.598 43.306 175.928 45.3597 175.928C47.4804 175.928 48.284 176.575 48.284 178.406V179.053L43.2391 179.589C41.0514 179.834 39.6674 180.727 39.6674 182.446C39.6674 184.277 41.1184 185.348 43.4176 185.348ZM42.0783 182.29C42.0783 181.419 42.681 181.129 43.9311 180.973L48.284 180.482C48.284 182.669 46.5875 183.607 44.065 183.607C42.681 183.607 42.0783 183.183 42.0783 182.29ZM55.0123 185.125V181.933H55.1686C55.6374 184.143 57.2669 185.348 59.7894 185.348C63.3165 185.348 65.2139 183.004 65.2139 179.589C65.2139 176.129 63.3388 173.807 59.9234 173.807C57.2669 173.807 55.7936 175.169 55.3472 177.044H55.2132V170.169H52.8023V185.125H55.0123ZM55.2132 179.701V179.522C55.2132 177.156 56.5749 175.995 59.0751 175.995C61.4413 175.995 62.803 176.91 62.803 179.589C62.803 182.245 61.4636 183.138 59.0304 183.138C56.6419 183.138 55.2132 182.022 55.2132 179.701ZM69.2959 185.125V170.169H66.885V185.125H69.2959ZM77.1091 185.348C80.4129 185.348 82.7344 183.719 82.7344 181.352V181.152H80.3236V181.33C80.3236 182.647 79.3637 183.406 77.0421 183.406C74.475 183.406 73.4258 182.268 73.3365 180.125H82.7568C82.8237 179.79 82.8461 179.477 82.8461 179.075C82.8461 175.705 80.5022 173.807 77.0644 173.807C73.4481 173.807 71.0819 176.129 71.0819 179.589C71.0819 183.295 73.4704 185.348 77.1091 185.348ZM77.0198 175.705C79.386 175.705 80.5691 176.687 80.5691 178.741V178.785H73.3588C73.4927 176.799 74.5643 175.705 77.0198 175.705ZM91.7259 185.348C94.2484 185.348 96.0119 184.232 96.5923 182.357H96.7485V185.125H98.9585V178.383C98.9585 175.727 97.3736 173.807 93.8466 173.807C90.3195 173.807 88.2212 175.705 88.2212 178.227V178.317H90.6097V178.227C90.6097 176.598 91.6143 175.928 93.668 175.928C95.7887 175.928 96.5923 176.575 96.5923 178.406V179.053L91.5473 179.589C89.3597 179.834 87.9756 180.727 87.9756 182.446C87.9756 184.277 89.4266 185.348 91.7259 185.348ZM90.3865 182.29C90.3865 181.419 90.9892 181.129 92.2393 180.973L96.5923 180.482C96.5923 182.669 94.8957 183.607 92.3732 183.607C90.9892 183.607 90.3865 183.183 90.3865 182.29ZM103.521 185.125V179.634C103.521 177.223 104.615 175.973 107.048 175.973C109.348 175.973 110.285 177.022 110.285 179.098V185.125H112.696V178.45C112.696 175.883 111.178 173.807 108.098 173.807C105.285 173.807 103.812 175.593 103.477 177.468H103.321V174.03H101.111V185.125H103.521ZM119.733 185.348C122.233 185.348 123.863 184.143 124.332 181.933H124.488V185.125H126.698V170.169H124.287V177.044H124.153C123.707 175.169 122.211 173.807 119.577 173.807C116.206 173.807 114.286 176.129 114.286 179.589C114.286 183.004 116.228 185.348 119.733 185.348ZM116.72 179.589C116.72 176.91 118.104 175.995 120.425 175.995C122.903 175.995 124.287 177.156 124.287 179.522V179.701C124.287 182.022 122.836 183.138 120.47 183.138C118.081 183.138 116.72 182.245 116.72 179.589ZM135.153 185.125V178.897C135.153 176.91 135.934 175.861 137.832 175.861C139.484 175.861 140.153 176.598 140.153 178.183V179.165H142.542V177.714C142.542 175.615 141.448 173.807 138.925 173.807C136.649 173.807 135.443 175.236 135.108 177.022H134.952V174.03H132.742V185.125H135.153ZM149.637 185.348C152.941 185.348 155.262 183.719 155.262 181.352V181.152H152.851V181.33C152.851 182.647 151.891 183.406 149.57 183.406C147.003 183.406 145.954 182.268 145.864 180.125H155.285C155.352 179.79 155.374 179.477 155.374 179.075C155.374 175.705 153.03 173.807 149.592 173.807C145.976 173.807 143.61 176.129 143.61 179.589C143.61 183.295 145.998 185.348 149.637 185.348ZM149.548 175.705C151.914 175.705 153.097 176.687 153.097 178.741V178.785H145.887C146.021 176.799 147.092 175.705 149.548 175.705ZM159.59 185.125V170.169H157.18V185.125H159.59ZM164.234 172.736V170.169H161.823V172.736H164.234ZM164.234 185.125V174.03H161.823V185.125H164.234ZM169.725 185.348C172.248 185.348 174.011 184.232 174.592 182.357H174.748V185.125H176.958V178.383C176.958 175.727 175.373 173.807 171.846 173.807C168.319 173.807 166.221 175.705 166.221 178.227V178.317H168.609V178.227C168.609 176.598 169.614 175.928 171.667 175.928C173.788 175.928 174.592 176.575 174.592 178.406V179.053L169.547 179.589C167.359 179.834 165.975 180.727 165.975 182.446C165.975 184.277 167.426 185.348 169.725 185.348ZM168.386 182.29C168.386 181.419 168.989 181.129 170.239 180.973L174.592 180.482C174.592 182.669 172.895 183.607 170.373 183.607C168.989 183.607 168.386 183.183 168.386 182.29ZM181.32 185.125V181.933H181.476C181.945 184.143 183.575 185.348 186.097 185.348C189.624 185.348 191.522 183.004 191.522 179.589C191.522 176.129 189.647 173.807 186.231 173.807C183.575 173.807 182.101 175.169 181.655 177.044H181.521V170.169H179.11V185.125H181.32ZM181.521 179.701V179.522C181.521 177.156 182.883 175.995 185.383 175.995C187.749 175.995 189.111 176.91 189.111 179.589C189.111 182.245 187.771 183.138 185.338 183.138C182.95 183.138 181.521 182.022 181.521 179.701ZM195.604 185.125V170.169H193.193V185.125H195.604ZM203.417 185.348C206.721 185.348 209.042 183.719 209.042 181.352V181.152H206.631V181.33C206.631 182.647 205.671 183.406 203.35 183.406C200.783 183.406 199.734 182.268 199.644 180.125H209.065C209.131 179.79 209.154 179.477 209.154 179.075C209.154 175.705 206.81 173.807 203.372 173.807C199.756 173.807 197.39 176.129 197.39 179.589C197.39 183.295 199.778 185.348 203.417 185.348ZM203.328 175.705C205.694 175.705 206.877 176.687 206.877 178.741V178.785H199.667C199.801 176.799 200.872 175.705 203.328 175.705ZM19.527 212.125V206.634C19.527 204.223 20.6209 202.973 23.0541 202.973C25.3533 202.973 26.2909 204.022 26.2909 206.098V212.125H28.7018V205.45C28.7018 202.883 27.1838 200.807 24.1032 200.807C21.2905 200.807 19.8172 202.593 19.4824 204.468H19.3261V201.03H17.1161V212.125H19.527ZM36.4307 212.348C39.7345 212.348 42.0561 210.719 42.0561 208.352V208.152H39.6452V208.33C39.6452 209.647 38.6853 210.406 36.3638 210.406C33.7966 210.406 32.7474 209.268 32.6582 207.125H42.0784C42.1454 206.79 42.1677 206.477 42.1677 206.075C42.1677 202.705 39.8238 200.807 36.3861 200.807C32.7698 200.807 30.4035 203.129 30.4035 206.589C30.4035 210.295 32.7921 212.348 36.4307 212.348ZM36.3414 202.705C38.7077 202.705 39.8908 203.687 39.8908 205.741V205.785H32.6805C32.8144 203.799 33.8859 202.705 36.3414 202.705ZM51.2507 212.125V209.96H49.2417C47.8576 209.96 47.2326 209.603 47.2326 208.241V203.04H51.2507V201.03H47.2326V198.597H44.844V201.03H42.9689V203.04H44.844V208.375C44.844 211.076 46.3174 212.125 48.7059 212.125H51.2507ZM58.0716 212.125L60.5271 205.741L61.3754 203.017H61.554L62.4023 205.741L64.8355 212.125H67.8267L71.1975 201.03H68.742L66.8892 207.326L66.3757 210.183H66.1972L65.3712 207.102L63.0273 201.03H59.9467L57.6251 207.102L56.7992 210.183H56.6206L56.1072 207.326L54.2544 201.03H51.7542L55.0803 212.125H58.0716ZM78.0921 212.348C81.7978 212.348 84.2756 210.004 84.2756 206.589C84.2756 203.129 81.7978 200.807 78.0921 200.807C74.4089 200.807 71.931 203.129 71.931 206.589C71.931 210.004 74.4089 212.348 78.0921 212.348ZM78.0921 210.205C75.4134 210.205 74.2972 208.933 74.2972 206.589C74.2972 204.223 75.4134 202.928 78.0921 202.928C80.7932 202.928 81.9094 204.223 81.9094 206.589C81.9094 208.933 80.7932 210.205 78.0921 210.205ZM88.436 212.125V205.897C88.436 203.91 89.2173 202.861 91.1148 202.861C92.7667 202.861 93.4364 203.598 93.4364 205.183V206.165H95.8249V204.714C95.8249 202.615 94.7311 200.807 92.2086 200.807C89.9317 200.807 88.7262 202.236 88.3914 204.022H88.2351V201.03H86.0252V212.125H88.436ZM99.7501 212.125V207.593H102.92L106.201 212.125H109.036L104.884 206.366L109.059 201.03H106.246L102.92 205.428H99.7501V197.169H97.3392V212.125H99.7501Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_6742",
    x1: 19.4661,
    y1: 182.688,
    x2: 19.4661,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_6742",
    x1: 54.4661,
    y1: 182.688,
    x2: 54.4661,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_6742",
    x1: 90.4661,
    y1: 182.688,
    x2: 90.4661,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_6742",
    x1: 126.466,
    y1: 182.688,
    x2: 126.466,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_6742",
    x1: 162.466,
    y1: 182.688,
    x2: 162.466,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_6742",
    x1: 197.466,
    y1: 182.688,
    x2: 197.466,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_6742",
    x1: 233.466,
    y1: 182.688,
    x2: 233.466,
    y2: 48.8352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_6742",
    x1: 269.17,
    y1: 18.9539,
    x2: -9.24119,
    y2: 18.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_6742",
    x1: 269.17,
    y1: 77.9539,
    x2: -9.24119,
    y2: 77.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_75_6742",
    x1: 269.17,
    y1: 47.9539,
    x2: -9.24119,
    y2: 47.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_75_6742",
    x1: 60,
    y1: 16.125,
    x2: 62.6601,
    y2: 133.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508459,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_75_6742",
    x1: 60,
    y1: 16.125,
    x2: 60,
    y2: 104.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDFCA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6742"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.125,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigbusiness3);
export default __webpack_public_path__ + "static/media/bigbusiness3.233baf7ea17c2a6b9db1b9484a6d76de.svg";
export { ForwardRef as ReactComponent };